<template>
  <div>
    <BrothersKaramazovArticle/>
    <CaledonianRoadArticle/>
    <LongIslandArticle/>
    <FrederickDouglassArticle/>
    <CrimeAndPunishmentArticle/>
    <TheLittleFriendArticle/>
    <EverythingIsTBArticle/>
    <TheArtOfUncertaintyArticle/>
    <NuclearWarArticle/>
    <FermatsLastTheoremArticle/>
    <TheMusicOfThePrimesArticle/>
    <PiazzollaArticle/>
    <JamesArticle/>
    <OrbitalArticle/>
    <YitzhakRabinArticle/>
  </div>
</template>

<script>
  import BrothersKaramazovArticle from '@/components/partials/articles/twentyfive/BrothersKaramazovArticle.vue'
  import CaledonianRoadArticle from '@/components/partials/articles/twentyfive/CaledonianRoadArticle.vue'
  import LongIslandArticle from '@/components/partials/articles/twentyfive/LongIslandArticle.vue'
  import FrederickDouglassArticle from '@/components/partials/articles/twentyfive/FrederickDouglassArticle.vue'
  import CrimeAndPunishmentArticle from '@/components/partials/articles/twentyfive/CrimeAndPunishmentArticle.vue'
  import TheLittleFriendArticle from '@/components/partials/articles/twentyfive/TheLittleFriendArticle.vue'
  import EverythingIsTBArticle from '@/components/partials/articles/twentyfive/EverythingIsTBArticle.vue'
  import TheArtOfUncertaintyArticle from '@/components/partials/articles/twentyfive/TheArtOfUncertaintyArticle.vue'
  import NuclearWarArticle from '@/components/partials/articles/twentyfive/NuclearWarArticle.vue'
  import FermatsLastTheoremArticle from '@/components/partials/articles/twentyfive/FermatsLastTheoremArticle.vue'
  import TheMusicOfThePrimesArticle from '@/components/partials/articles/twentyfive/TheMusicOfThePrimesArticle.vue'
  import PiazzollaArticle from '@/components/partials/articles/twentyfive/PiazzollaArticle.vue'
  import JamesArticle from '@/components/partials/articles/twentyfive/JamesArticle.vue'
  import OrbitalArticle from '@/components/partials/articles/twentyfive/OrbitalArticle.vue'
  import YitzhakRabinArticle from '@/components/partials/articles/twentyfive/YitzhakRabinArticle.vue'



  export default {
  name: 'App',
  components: {
    JamesArticle,
    OrbitalArticle,
    YitzhakRabinArticle,
    PiazzollaArticle,
    TheMusicOfThePrimesArticle,
    FermatsLastTheoremArticle,
    NuclearWarArticle,
    TheArtOfUncertaintyArticle,
    EverythingIsTBArticle,
    TheLittleFriendArticle,
    CrimeAndPunishmentArticle,
    FrederickDouglassArticle,
    LongIslandArticle,
    CaledonianRoadArticle,
    BrothersKaramazovArticle
  }
}
</script>